<template>
<!-- 辞书世界 - 融媒辞书管理 -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <el-input
          placeholder="请输入"
          v-model.trim="searchInfo"
          style="min-width: 300px;"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right;">
        <el-button v-on:click="addActivity" type="primary" style="width: 80px" v-if="isManage"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-if="isManage"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
        >
        <el-table-column align="center" type="selection" width="55"/>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="name"
          label="书名"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="id"
          label="图书ID"
          width="100"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="clazz"
          label="图书分类"
          align="center"
          width="120"
          >
          <template slot-scope="scope">
            <span>{{getBookType(scope.row.clazz)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="上传时间"
          align="center"
          width="160"
          :formatter="formatter"
          >
        </el-table-column>

        <el-table-column
          prop="status"
          width="120"
          align="center"
          label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status=='0'" type="success">发布中</el-tag>
            <el-tag v-if="scope.row.status=='1'" type="info">未发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="置顶顺序"
          align="center"
          width="120"
          >

        </el-table-column>

        <el-table-column
          prop="operate"
          width="260"
          align="center"
          v-if="isManage"
          :key="Math.random()"
          label="管理操作">
          <template slot-scope="scope">
            <!-- <i class="el-icon-view" v-if="scope.row.coverFile" @click="handleClickView(scope.row)"></i>
            <el-popover
                v-else
                placement="bottom"
                title=""
                width="200"
                trigger="click"
                content="暂无图片"
                >
                <i class="el-icon-view" slot="reference" ></i>
              </el-popover> -->
            <el-tooltip class="item" effect="light"  content="预览" placement="bottom" >
            <i class="el-icon-view" @click="handleClickView(scope.row)" ></i>
            </el-tooltip>
            <i class="el-icon-edit" @click="handleEditClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
            <i class="iconfont el-icon-mydownloadshuyi_zhiding" @click="handleToTop(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dictionaryApi from '@/api/dictionaryWorld/index.js'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import { checkRole } from '@/utils/auth'
import { getMyDate } from '@/utils/timeUtils.js'
export default {
  data () {
    return {
      loading: false,
      thumbPath: '',
      filePath: '',
      isManage: false, // 是否是管理用户
      dialogVisible: false,
      dialogImageUrl: '',
      selectBookValue: '',
      optionStatus: '',
      searchInfo: '',
      options: [],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleBookList()
    this.isManage = checkRole(['manage'])
  },
  methods: {
    ...mapRequestActions(dictionaryApi),

    /**
     * 获取融媒辞书列表
     */
    handleBookList () {
      this.queryDicListAction({
        clazz: this.selectBookValue,
        name: this.searchInfo,
        remark: '1',
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then(res => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },

    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleBookList()
    },

    searchHandler () {
      this.handleBookList()
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 新增
     */
    addActivity () {
      this.$router.push('/dictionaries-digital-media-add')
    },
    /**
     * 预览
     */
    handleClickView (item) {
      this.$router.push({ path: '/dictionaries-digital-media-edit', query: { id: item.id, isView: true } })
    },
    /**
     * 编辑
     */
    handleEditClick (item) {
      this.$router.push({
        path: '/dictionaries-digital-media-edit', query: { id: item.id }
      })
    },
    /**
     * 置顶
     */
    async handleToTop (item) {
      const resultData = await this.setTopOneAction({ id: item.id })
      if (resultData.status) {
        this.$message.success('置顶成功')
        this.handleBookList()
      } else {
        this.$message.error('操作失败')
      }
    },
    formatter (row, column, cellValue) {
      if (row) { return getMyDate(row.createTime) }
    },

    /**
     * 获取图书分类type
     */
    getBookType (type) {
      switch (type) {
        case 1:
          return '汉语辞书'
        case 2:
          return '外语辞书'
        case 3:
          return '民族语辞书'
        case 4:
          return '数字辞书'
        case 5:
          return '融媒辞书'
        case 6:
          return '专科辞书'
        case 7:
          return '百科辞书'
      }
    },
    /**
     * 删除 全选操作
     */
    delClick () {
      const _this = this
      MessageBox.confirm('此操作将永久删除该辞书, 是否继续?', '提示').then(() => {
        const longIds = _this.selectArr.map(item => item.id)
        this.deleteDictByIdsAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
            _this.handleBookList()
          } else {
            _this.$message.error({ message: res.data.msg || '删除失败' })
          }
        })
      })
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该辞书, 是否继续?', '提示').then(() => {
        const longIds = [item.id]
        this.deleteDictByIdsAction({ longIds }).then(res => {
          if (res.status) {
            _this.$message.success('删除成功')
            _this.handleBookList()
          } else {
            _this.$message.error({ message: res.data.msg || '删除失败' })
          }
        })
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "./index.less";
</style>
